module.exports = __webpack_public_path__ + "static/media/NE.cd7b2703.jpg";